import {
  Col,
  ColType,
  Crud,
  CrudAction,
  CrudApi,
  CrudOption,
} from "../../comp/crud";
import "./leadCrud.css";
import "./leadImport.css";
import {
  ApiClient,
  displayLeadAssignStatus,
  displayLeadStatus,
  getLeadAssignStatusOpt,
  getLeadStatusOpt,
  displayLeadType,
  getLeadTypeOpt,
  Lead,
  getLeadStatItemOpt,
  getMyLeadStatItemOpt,
  LeadAssignLog,
  LeadStarLog,
} from "../../api/ApiClient";
import React, { useContext, useEffect, useState, useRef } from "react";
import { LeadDetail } from "./leadDetail";
import {
  displayStar,
  formatDuration,
  formatRelativeTime,
  formatAmountZhCn,
  formatPercent,
  formatDateTime,
  formatDate,
} from "../../utils";
import {
  Button,
  Form,
  Modal,
  Toast,
  TagInput,
  withField,
  Tooltip,
  Descriptions,
  Tag,
  Row,
  Col as RowCol,
  Highlight,
  Progress,
  Banner,
  Popover,
  Spin,
} from "@douyinfe/semi-ui";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";
import {
  IconActivity,
  IconCloudUploadStroked,
  IconHelpCircle,
  IconModalStroked,
} from "@douyinfe/semi-icons";
import { FavButton } from "./favButton";
import { TextCell, TextCellRemark } from "../../comp/cell";
import { SiteInfoContext } from "../context/SiteInfoContext";
import pubsub from "pubsub-js";
import { useLocation } from "react-router-dom";
import LeadImportLogDetail from "../leadImportLog/indexDetail";

const apiClient = ApiClient.getDefault();
const TagInputField = withField(TagInput);

/** 星级/状态列的悬浮弹窗：左侧分配记录 + 右侧星级状态列表，时间轴布局 */
function LeadLogPopover({ leadId, children }: { leadId: number; children: React.ReactNode }) {
  const [assignLogs, setAssignLogs] = useState<LeadAssignLog[]>([]);
  const [starLogs, setStarLogs] = useState<LeadStarLog[]>([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const fetchData = async () => {
    if (loaded) return;
    setLoading(true);
    try {
      const [assigns, stars] = await Promise.all([
        apiClient.getAllLeadAssignLogs(leadId),
        apiClient.getAllLeadStarLogs(leadId),
      ]);
      setAssignLogs(assigns);
      setStarLogs(stars);
      setLoaded(true);
    } catch (e) {
      console.error("加载日志失败:", e);
    } finally {
      setLoading(false);
    }
  };

  const timelineItemStyle: React.CSSProperties = {
    position: "relative",
    paddingLeft: 24,
    paddingBottom: 16,
    borderLeft: "2px solid var(--semi-color-border)",
    marginLeft: 8,
  };
  const dotStyle: React.CSSProperties = {
    position: "absolute",
    left: -6,
    top: 2,
    width: 10,
    height: 10,
    borderRadius: "50%",
    border: "2px solid var(--semi-color-bg-0)",
  };
  const lastTimelineItemStyle: React.CSSProperties = {
    ...timelineItemStyle,
    paddingBottom: 0,
    borderLeft: "none",
  };

  const renderAssignLogs = () => {
    if (assignLogs.length === 0) {
      return <div style={{ textAlign: "center", padding: "20px 0", color: "var(--semi-color-text-2)" }}>暂无分配记录</div>;
    }
    return assignLogs.map((l, i) => {
      const isLast = i === assignLogs.length - 1;
      return (
        <div key={i} style={isLast ? lastTimelineItemStyle : timelineItemStyle}>
          <div style={{ ...dotStyle, background: "var(--semi-color-primary)" }} />
          <div style={{
            background: "var(--semi-color-fill-0)",
            borderRadius: 6,
            padding: "8px 12px",
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 4, marginBottom: 4, flexWrap: "wrap" }}>
              <span style={{
                padding: "1px 6px",
                background: "var(--semi-color-warning-light)",
                borderRadius: 4,
                fontSize: 12,
                fontWeight: 500,
              }}>{l.assignBy}</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
                <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="var(--semi-color-primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span style={{
                padding: "1px 6px",
                background: "var(--semi-color-primary-light)",
                borderRadius: 4,
                fontSize: 12,
                fontWeight: 600,
              }}>{l.saleName}</span>
              <span style={{ fontSize: 11, color: "var(--semi-color-text-2)", marginLeft: "auto" }}>{formatRelativeTime(l.createdAt)}</span>
            </div>
            {l.remark && (
              <div style={{
                padding: "4px 8px",
                background: "var(--semi-color-bg-0)",
                borderRadius: 4,
                fontSize: 12,
                color: "var(--semi-color-text-1)",
                lineHeight: 1.5,
                marginTop: 4,
              }}>{l.remark}</div>
            )}
          </div>
        </div>
      );
    });
  };

  const renderStarLogs = () => {
    if (starLogs.length === 0) {
      return <div style={{ textAlign: "center", padding: "20px 0", color: "var(--semi-color-text-2)" }}>暂无星级状态记录</div>;
    }
    return starLogs.map((l, i) => {
      const isLast = i === starLogs.length - 1;
      return (
        <div key={i} style={isLast ? lastTimelineItemStyle : timelineItemStyle}>
          <div style={{ ...dotStyle, background: "var(--semi-color-warning)" }} />
          <div style={{
            background: "var(--semi-color-fill-0)",
            borderRadius: 6,
            padding: "8px 12px",
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
              <span style={{ fontWeight: 500, fontSize: 12, color: "var(--semi-color-text-0)" }}>{l.saleName}</span>
              <span style={{ fontSize: 11, color: "var(--semi-color-text-2)" }}>{formatRelativeTime(l.createdAt)}</span>
            </div>
            <div style={{
              display: "flex", alignItems: "center", gap: 8,
              padding: "4px 8px", background: "var(--semi-color-bg-0)", borderRadius: 4,
            }}>
              <span style={{ fontSize: 12, color: "var(--semi-color-text-2)" }}>星级：</span>
              <span style={{ fontWeight: 600, fontSize: 13, color: "var(--semi-color-warning)" }}>{displayStar(l.star)}</span>
              <span style={{ fontSize: 12, color: "var(--semi-color-text-2)", marginLeft: 4 }}>状态：</span>
              <Tag size="small">{displayLeadStatus(l.status)}</Tag>
            </div>
            {l.remark && (
              <div style={{
                padding: "4px 8px",
                background: "var(--semi-color-warning-light)",
                borderRadius: 4,
                fontSize: 12,
                color: "var(--semi-color-text-1)",
                lineHeight: 1.5,
                marginTop: 4,
              }}>{l.remark}</div>
            )}
          </div>
        </div>
      );
    });
  };

  const content = (
    <div style={{ width: 600 }}>
      {loading ? (
        <div style={{ textAlign: "center", padding: "30px 0" }}><Spin /></div>
      ) : (
        <div style={{ display: "flex", gap: 16 }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{
              fontSize: 13, fontWeight: 600, color: "var(--semi-color-text-0)",
              marginBottom: 12, display: "flex", alignItems: "center", gap: 6,
            }}>
              <span style={{ color: "var(--semi-color-primary)" }}>●</span> 分配记录
            </div>
            <div style={{ maxHeight: 320, overflowY: "auto", paddingRight: 4 }}>
              {renderAssignLogs()}
            </div>
          </div>
          <div style={{ width: 1, background: "var(--semi-color-border)", flexShrink: 0 }} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{
              fontSize: 13, fontWeight: 600, color: "var(--semi-color-text-0)",
              marginBottom: 12, display: "flex", alignItems: "center", gap: 6,
            }}>
              <span style={{ color: "var(--semi-color-warning)" }}>●</span> 星级状态
            </div>
            <div style={{ maxHeight: 320, overflowY: "auto", paddingRight: 4 }}>
              {renderStarLogs()}
            </div>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="hover"
      position="bottom"
      onVisibleChange={(visible) => { if (visible) fetchData(); }}
      showArrow
      arrowPointAtCenter
      mouseEnterDelay={100}
      mouseLeaveDelay={200}
      style={{ maxWidth: 640 }}
    >
      <span style={{ cursor: "pointer", display: "inline-block" }}>{children}</span>
    </Popover>
  );
}

export interface LeadCrudProps {
  name: string;
  type: LeadsType;
  router: string;
}

export type LeadsType =
  | "all"
  | "my"
  | "new"
  | "fav"
  | "team"
  | "pool"
  | "waste"
  | "cancellation"
  | "reject";

export function LeadCurd(props: LeadCrudProps) {
  const { state } = useLocation();
  const activiRoute = useLocation().pathname.replace("/", "");
  const siteInfo = useContext(SiteInfoContext);
  const [teamMembers, setTeamMembers] = useState([] as CrudOption[]);
  const [teamMembersTree, setTeamMembersTree] = useState([] as any[]);
  const [teamCitys, setTeamCitys] = useState([] as any[]);
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  // const crudApiRef = useRef(crudApi);
  // crudApiRef.current = crudApi;
  const [filterFormApi, setFilterFormApi] = useState(
    undefined as undefined | FormApi
  );
  // const filterFormApiRef = useRef(filterFormApi);
  // filterFormApiRef.current = filterFormApi;
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showTransAssignModal, setShowTransAssignModal] = useState(false);
  const [showPoolModal, setShowPoolModal] = useState(false);
  const [showWasteModal, setShowWasteModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [assignFormApi, setAssignFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [transAssignFormApi, setTransAssignFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [poolFormApi, setPoolFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [wasteFormApi, setWasteFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [deleteFormApi, setDeleteFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [selectedLeads, setSelectedLeads] = useState([] as any[]);
  const [assignSaving, setAssignSaving] = useState(false);
  const [poolSaving, setPoolSaving] = useState(false);
  const [wasteSaving, setWasteSaving] = useState(false);
  const [showFindModal, setShowFindModal] = useState(false);
  const [findFormApi, setFindFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [finding, setFinding] = useState(false);
  const [leadIds, setLeadIds] = useState([] as number[]);
  const [importing, setImporting] = useState(false);
  const username = localStorage.getItem("username");
  const role = localStorage.getItem("role");
  const city = localStorage.getItem("city");
  const [saving, setSaving] = useState(false);
  const [selectedMembers, setSelectedMembers] = useState([] as any[]);
  const selectedMembersRef = useRef(selectedMembers);
  const [statData, setStatData] = useState([] as any[]);
  const [statDataObj, setStatDataObj] = useState([] as any);
  const [statLoading, setStatLoading] = useState(false);
  const sourceString =
    "满足以下三个条件，1、客户在指定日期内有过撞库 2、客户n天未跟进 3、客户在公共池";
  const searchWords = ["撞库", "n天未跟进", "公共池"];
  const [pageSize, setPageSize] = useState(50);

  const [taskId, setTaskId] = useState(undefined as any);
  const [showImportModal, setShowImportModal] = useState(false);
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState("pending");
  const [importData, setImportData] = useState({
    total: 0,
    processed: 0,
    success: 0,
    fail: 0,
    processing: "",
    assignSuccess: 0,
    assignFail: 0,
    errors: [],
  });
  const [file, setFile] = useState(null as null | any);
  const [isImporting, setIsImporting] = useState(false);
  const [visibleErrors, setVisibleErrors] = useState(false);
  const [importLeadType, setImportLeadType] = useState("");

  const [showCancellationModal, setShowCancellationModal] = useState(false);
    const [cancellationFormApi, setCancellationFormApi] = useState(
        undefined as undefined | FormApi
    );
  const [cancellationSaving, setCancellationSaving] = useState(false);
  const [canCreateLead, setCanCreateLead] = useState(true);


  // 处理文件上传
  const handleFileChange = (e: any) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  // 启动导入任务
  const startImport = async () => {
    if (!importLeadType) {
      Toast.error("导入客户类型不能为空");
      return;
    }
    let msg = "";
    if ("NEW" == importLeadType) {
      msg = "当前为新客户导入，是否确定导入？";
    } else if ("MY" == importLeadType) {
      msg = "当前为再分配客户导入，是否确定导入？";
    } else {
      Toast.error("导入客户类型不正确");
      return;
    }
    if (!file) {
      Toast.error("请先选择Excel文件");
      return;
    }
    // 确认弹窗
    Modal.confirm({
      title: "导入确认",
      content: msg,
      okText: "确定",
      cancelText: "取消",
      onOk: async () => {
        setIsImporting(true);
        try {
          const response = await apiClient.request<any>(
            "/leads/importBest?leadType=" + importLeadType,
            "POST",
            undefined,
            undefined,
            file
          );

          setTaskId(response.data);
          //Toast.success("导入任务已启动");
        } catch (error: any) {
          Toast.error("导入启动失败: " + error.message);
          setIsImporting(false);
        }
      },
    });
  };

  // 更新StatCard组件以使用CSS类
  const StatCard = ({ title, value, type = "normal" }: any) => {
    return (
      <div className={`stat-card stat-card-${type}`}>
        <div className="stat-title">{title}</div>
        <div className="stat-value">{value}</div>
      </div>
    );
  };

  // 轮询导入进度
  useEffect(() => {
    if (!taskId) return;

    let count = 0;
    let elapsedTime = 0; // 记录已过去的时间
    let intervalId;

    const pollStatus = async () => {
      count++;
      // 达到500次后停止
      if (count >= 500) {
        clearInterval(intervalId);
        clearTimeout(switchInterval);
        console.log("已执行500次，停止");
        return;
      }

      try {
        const response = await apiClient.request<any>(
          "/leads/importBest/status/" + taskId,
          "GET",
          undefined,
          undefined,
          undefined
        );
        const taskStatus: any = response.data;
        let processing = "";
        setProgress(taskStatus.progress);
        setStatus(taskStatus.status.toLowerCase());

        if (taskStatus.processed == 5) {
          processing = taskStatus.processing+" 分配成功："+taskStatus.assignSuccess+" 失败："+taskStatus.assignFail ;
        }else{
          processing = taskStatus.processing;
        }

        // 任务完成时清理
        if (
          taskStatus.status === "COMPLETED" ||
          taskStatus.status === "FAILED" ||
          taskStatus.total === 0
        ) {
          clearInterval(intervalId);
          clearTimeout(switchInterval);
          setIsImporting(false);
          processing = "已结束";
          if (taskStatus.status === "COMPLETED") {
            Toast.success(
              `导入完成！成功: ${taskStatus.success}, 失败: ${taskStatus.fail}`
            );
          }
        }

        setImportData({
          total: taskStatus.total,
          processed: taskStatus.processed,
          success: taskStatus.success,
          fail: taskStatus.fail,
          errors: taskStatus.errors,
          processing: processing,
          assignSuccess: taskStatus.assignSuccess,
          assignFail: taskStatus.assignFail,
        });
      } catch (error) {
        console.error("获取进度失败:", error);
      }
    };

    // 立即执行第一次轮询
    pollStatus();

    // 设置初始定时器（前10秒每秒执行）
    intervalId = setInterval(pollStatus, 1000);

    // 10秒后切换到5秒间隔
    const switchInterval = setTimeout(() => {
      clearInterval(intervalId);
      intervalId = setInterval(pollStatus, 5000);
    }, 10000);

    // 清理函数
    return () => {
      clearInterval(intervalId);
      clearTimeout(switchInterval);
    };
  }, [taskId]);

  let cols: Col[] = [
    {
      name: "备注",
      key: "q",
      showInFilter: false,
      hideInList: true,
      hideInCreate: true,
      type: ColType.STRING,
    },
    {
      name: "客户ID",
      key: "id",
      colFilterSort: 0,
      showInFilter: true,
      hideInEdit: true,
      hideInList: true,
      type: ColType.STRING,
    },
    {
      name: "姓名",
      key: "name",
      width: 80,
      colSort: 1,
      colFilterSort: 1,
      showInFilter: true,
      type: ColType.STRING,
      render: (value, record, index) => {
        if (record.status == "PENDING_CONTACT") {
          return (
            <Button
              theme="borderless"
              type="danger"
              onClick={() => detailAction(record, crudApi?.getData())}
            >
              {value}
            </Button>
          );
        } else if (record.againAssign) {
          return (
            <Button
              theme="borderless"
              type="primary"
              onClick={() => detailAction(record, crudApi?.getData())}
            >
              {value}
            </Button>
          );
        } else {
          return (
            <Button
              theme="borderless"
              type="tertiary"
              onClick={() => detailAction(record, crudApi?.getData())}
            >
              {value}
            </Button>
          );
        }
      },
    },
    {
      name: "客户类型",
      key: "leadType",
      colSort: 1,
      colFilterSort: 6,
      showInFilter: true,
      hideInCreate: true,
      render: (value, index) => displayLeadType(value),
      getOptions: () => Promise.resolve(getLeadTypeOpt()),
      type: ColType.SELECT,
      width: 100,
    },
    {
      name: "手机",
      key: "mobile",
      showInFilter: true,
      colFilterSort: 2,
      hideInList: true,
      type: ColType.STRING,
    },
    // {
    //     name: "IP城市",
    //     key: "ipCity",
    //     showInFilter: true,
    //     hideInCreate: true,
    //     type: ColType.STRING
    // },

    {
      name: "城市",
      key: "applyCity",
      width: 50,
      colSort: 2,
      showInFilter: true,
      colFilterSort: 4,
      type: ColType.SELECT,
      getOptions: () => apiClient.getDictAsOpts("city"),
    },

    {
      name: "金额",
      key: "applyAmount",
      width: 80,
      colSort: 4,
      colFilterSort: 7,
      type: ColType.STRING,
      render: (a) => formatAmountZhCn(a),
    },
    {
      name: "星级",
      key: "star",
      width: 50,
      colSort: 5,
      colFilterSort: 5,
      showInFilter: false,
      hideInCreate: true,
      render: (a, record) => (
        <LeadLogPopover leadId={record.id}>
          {displayStar(a)}
        </LeadLogPopover>
      ),
      getOptions: () =>
        Promise.resolve([
          { label: "0星", value: "0", key: "0" },
          { label: "1星", value: "1", key: "1" },
          { label: "2星", value: "2", key: "2" },
          { label: "3星", value: "3", key: "3" },
          { label: "4星", value: "4", key: "4" },
          { label: "5星", value: "5", key: "5" },
        ]),
      type: ColType.SELECT,
    },
    {
          name: "星级",
          key: "stars",
          width: 90,
          hideInList: true,
          showInFilter: true,
          hideInCreate: true,
          type: ColType.MULTI_SELECT,
          getOptions: () =>
        Promise.resolve([
          { label: "0星", value: "0", key: "0" },
          { label: "1星", value: "1", key: "1" },
          { label: "2星", value: "2", key: "2" },
          { label: "3星", value: "3", key: "3" },
          { label: "4星", value: "4", key: "4" },
          { label: "5星", value: "5", key: "5" },
        ]),
        },
    {
        name: "分配者",
        key: "assignBy",
        hideInCreate: true,
        showInFilter: true,
        hideInList: true,
        type: ColType.STRING
    },
    {
      name: "状态",
      key: "status",
      width: 70,
      colSort: 3,
      showInFilter: true,
      colFilterSort: 3,
      hideInCreate: true,
      render: (value, record) => {
        let tagNode: React.ReactNode;
        if (value == "PENDING_CONTACT") {
          tagNode = (
            <Tag
              color="red"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {displayLeadStatus(value)}
            </Tag>
          );
        } else if (value == "UNREACHABLE") {
          tagNode = (
            <Tag
              color="blue"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {displayLeadStatus(value)}
            </Tag>
          );
        } else if (value == "OUT_LEAD") {
          tagNode = (
            <Tag
              color="grey"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {displayLeadStatus(value)}
            </Tag>
          );
        } else if (value == "INVITATION_IN_PROGRESS") {
          tagNode = (
            <Tag
              color="orange"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {displayLeadStatus(value)}
            </Tag>
          );
        } else if (value == "NON_COMPLIANCE") {
          tagNode = (
            <Tag
              color="teal"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {displayLeadStatus(value)}
            </Tag>
          );
        } else if (value == "PENDING_VISIT") {
          tagNode = (
            <Tag
              color="purple"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {displayLeadStatus(value)}
            </Tag>
          );
        } else if (value == "VISITED") {
          tagNode = (
            <Tag
              color="green"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {displayLeadStatus(value)}
            </Tag>
          );
        } else if (value == "SIGNED_CONTRACT") {
          tagNode = (
            <Tag
              color="violet"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {displayLeadStatus(value)}
            </Tag>
          );
        } else if (value == "PAID") {
          tagNode = (
            <Tag
              color="yellow"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {displayLeadStatus(value)}
            </Tag>
          );
        } else {
          tagNode = (
            <Tag key={value} size="large" shape="circle" type="solid">
              {displayLeadStatus(value)}
            </Tag>
          );
        }
        return (
          <LeadLogPopover leadId={record.id}>
            {tagNode}
          </LeadLogPopover>
        );
      },
      getOptions: () => Promise.resolve(getLeadStatusOpt()),
      type: ColType.SELECT,
    },
    {
      name: "跟进记录",
      key: "contactLogs",
      colSort: 8,
      hideInEdit: true,
      width: 210,
      hideInCreate: true,
      showInFilter: true,
      render: (value, index) => (
        <TextCellRemark moreText={value ? value : []} width={200} />
      ),
      type: ColType.STRING,
    },
    {
      name: "跟进数",
      key: "contactLogCount",
      colSort: 8,
      hideInEdit: true,
      hideInCreate: true,
      type: ColType.STRING,
      defaultSortOrder: false,
      width: 60,
    },
    {
      name: "资质",
      key: "remark",
      colSort: 7,
      type: ColType.STRING,
      width: 210,
      hideInCreate: true,
      showInFilter: true,
      render: (a, b, c) => <TextCell text={b.remark} width={200} />,
    },
    {
      name: "入库时间",
      key: "createdAt",
      colSort: 11,
      hideInCreate: true,
      showInFilter: true,
      width: 150,
      type: ColType.DATE_RANGE,
      defaultSortOrder: [
        "new",
        "fav",
        "my",
        "all",
        "team",
        "pool",
        "waste",
        "cancellation",
        "reject",
      ].includes(props.type)
        ? false
        : undefined,
      render: (a: any) => <TextCell text={formatRelativeTime(a)} width={150} />,
    },
    {
      name: "房产",
      key: "house",
      optional: true,
      type: ColType.SELECT,
      showInPlusFilter: true,
      hideInCreate: true,
      hideInList: true,
      getOptions: () => apiClient.getDictAsOpts("house"),
    },
    {
      name: "车产",
      key: "vehicle",
      optional: true,
      type: ColType.SELECT,
      showInPlusFilter: true,
      hideInCreate: true,
      hideInList: true,
      getOptions: () => apiClient.getDictAsOpts("vehicle"),
    },
    {
      name: "工作",
      key: "job",
      optional: true,
      type: ColType.SELECT,
      showInPlusFilter: true,
      hideInCreate: true,
      hideInList: true,
      getOptions: () => apiClient.getDictAsOpts("job"),
    },
    {
      name: "公积金",
      key: "providentFund",
      optional: true,
      type: ColType.SELECT,
      showInPlusFilter: true,
      hideInCreate: true,
      hideInList: true,
      getOptions: () => apiClient.getDictAsOpts("providentFund"),
    },
    {
      name: "社保",
      key: "socialSecurity",
      type: ColType.SELECT,
      optional: true,
      showInPlusFilter: true,
      hideInCreate: true,
      hideInList: true,
      getOptions: () => apiClient.getDictAsOpts("socialSecurity"),
    },
    {
      name: "公司",
      key: "company",
      type: ColType.SELECT,
      optional: true,
      showInPlusFilter: true,
      hideInCreate: true,
      hideInList: true,
      getOptions: () => apiClient.getDictAsOpts("company"),
    },
    {
      name: "保险",
      key: "assurance",
      showInPlusFilter: true,
      optional: true,
      hideInCreate: true,
      type: ColType.SELECT,
      hideInList: true,
      getOptions: () => apiClient.getDictAsOpts("assurance"),
    },

    {
      name: "信用",
      key: "credit",
      optional: true,
      type: ColType.SELECT,
      showInPlusFilter: true,
      hideInCreate: true,
      hideInList: true,
      getOptions: () => apiClient.getDictAsOpts("credit"),
    },
    {
      name: "婚姻",
      key: "marriage",
      optional: true,
      type: ColType.SELECT,
      showInPlusFilter: true,
      hideInCreate: true,
      hideInList: true,
      getOptions: () => apiClient.getDictAsOpts("marriage"),
    },
    {
      name: "性别",
      key: "gender",
      showInPlusFilter: true,
      optional: true,
      hideInCreate: true,
      type: ColType.SELECT,
      hideInList: true,
      getOptions: () => apiClient.getDictAsOpts("gender"),
    },
    {
      name: "预计上门时间",
      key: "estVisitTime",
      showInFilter: false,
      hideInList: true,
      hideInCreate: true,
      type: ColType.DATE_RANGE,
    },
    {
      name: "实际上门时间",
      key: "actVisitTime",
      showInFilter: false,
      hideInList: true,
      hideInCreate: true,
      type: ColType.DATE_RANGE,
    },
    {
      name: "未跟进天数",
      key: "notContactDays",
      showInFilter: false,
      hideInCreate: true,
      hideInList: true,
      type: ColType.NUMBER,
    },
  ];
  let rootTeamCol = {
    name: "团队",
    colSort: 2,
    key: "rootTeamId",
    showInFilter: false,
    hideInList: true,
    type: ColType.SELECT,
    getOptions: () => apiClient.getCurrentRootTeamAsOpts(),
  };
  let costCol = {
    name: "成本",
    key: "cost",
    hideInCreate: false,
    type: ColType.NUMBER,
  };
  let saleIdCol = {
    name: "销售",
    key: "saleIds",
    width: 70,
    colSort: 3,
    hideInCreate: true,
    showInFilter: true,
    hideInList: true,
    type: ColType.TREE_MUL,
    getOptions: () => {
      if (role == "op_manager" || role == "monitor") {
        return apiClient.getTeamMemberTreeAsOpts("root");
      } else {
        return apiClient.getTeamMemberTreeAsOpts(username);
      }
    },
  };
  let saleNameCol = {
    name: "销售",
    key: "saleName",
    width: 70,
    colSort: 3,
    hideInCreate: true,
    type: ColType.STRING,
  };
  let teamIdCol = {
    name: "团队",
    key: "teamId",
    colSort: 3,
    hideInCreate: true,
    showInFilter: true,
    hideInList: true,
    type: ColType.TREE,
    getOptions: () => apiClient.getTeamAsOpts(),
  };
  let teamNameCol = {
    name: "团队",
    key: "teamName",
    width: 120,
    hideInCreate: true,
    type: ColType.STRING,
  };
  let assignStatusCol = {
    name: "分配状态",
    key: "assignStatus",
    showInFilter: true,
    hideInCreate: true,
    hideInList: true,
    type: ColType.SELECT,
    render: (a: any) => displayLeadAssignStatus(a),
    getOptions: () => Promise.resolve(getLeadAssignStatusOpt()),
  };
  let sourceCol = {
    name: "来源",
    key: "source",
    width: 70,
    showInFilter: true,
    optional: true,
    type: ColType.STRING,
  };
  let sourceTeamCol = {
    name: "来源",
    key: "source",
    showInFilter: true,
    hideInList: true,
    optional: true,
    type: ColType.STRING,
  };
  let refOrderNoCol = {
    name: "外部单号",
    key: "refOrderNo",
    showInFilter: true,
    hideInCreate: true,
    type: ColType.STRING,
  };
  let platformCol = {
    name: "平台",
    key: "platform",
    optional: true,
    hideInCreate: true,
    showInFilter: true,
    type: ColType.SELECT,
    getOptions: () =>
      Promise.resolve([
        {
          label: "API",
          value: "api",
          key: "api",
        },
        {
          label: "线下",
          value: "offline",
          key: "offline",
        },
      ]),
  };
  let assignAtCol: Col = {
    name: "分配时间",
    key: "assignedAt",
    colSort: 10,
    defaultSortOrder: ["new", "fav", "my", "team"].includes(props.type)
      ? "descend"
      : undefined,
    hideInCreate: true,
    showInFilter: true,
    type: ColType.DATE_RANGE,
    render: (a: any) => <TextCell text={formatRelativeTime(a)} width={150} />,
    width: 150,
  };

  let assignAtColAll: Col = {
    name: "分配时间",
    key: "assignedAt",
    colSort: 10,
    defaultSortOrder: false,
    hideInCreate: true,
    showInFilter: false,
    type: ColType.DATE_RANGE,
    render: (a: any) => <TextCell text={formatRelativeTime(a)} width={150} />,
    width: 150,
  };

  let lastContactAt = {
    name: "上次联系时间",
    key: "lastContactAt",
    colSort: 9,
    hideInCreate: true,
    showInFilter: false,
    defaultSortOrder: ["new", "fav", "my", "team", "all", "pool"].includes(props.type)
      ? false
      : undefined,
    type: ColType.DATE_RANGE,
    render: (a: any) => <TextCell text={formatRelativeTime(a)} width={150} />,
    width: 150,
  };
  let sendToPoolAtCol: Col = {
    name: "回流时间",
    key: "sentToPoolAt",
    colSort: 12,
    width: 150,
    hideInCreate: true,
    showInFilter: false,
    defaultSortOrder: [
      "new",
      "fav",
      "my",
      "all",
      "team",
      "pool",
      "waste",
      "cancellation",
      "reject",
    ].includes(props.type)
      ? "descend"
      : undefined,
    type: ColType.DATE_RANGE,
    render: (a: any) => <TextCell text={formatRelativeTime(a)} width={150} />,
  };
  let poolCountDownCol = {
    name: "公共池倒计时",
    key: "poolCountDown",
    defaultSortOrder: ["new", "fav", "my"].includes(props.type)
      ? false
      : undefined,
    hideInCreate: true,
    type: ColType.STRING,
    render: (a: any) => formatDuration(a),
    width: 70,
  };

  let nowDate = new Date();
  //过去3天
  let startDate = new Date();
  startDate.setDate(startDate.getDate() - 3);
  let nowDateStr = formatDate(nowDate);
  let startDateStr = formatDate(startDate);
  //打印日期
  console.log("日期" + nowDateStr);
  let initFilterValues = {
    rejectedAt: [""],
  };

  let initParams = {
    rejectedAt: "",
  };
  let rejectedAtCol: Col = {
    name: "撞库时间",
    key: "rejectedAt",
    colSort: -1,
    colFilterSort: -1,
    width: 150,
    hideInCreate: true,
    showInFilter: true,
    defaultSortOrder: ["reject"].includes(props.type) ? "descend" : undefined,
    type: ColType.DATE_RANGE,
    render: (a: any) => <TextCell text={formatRelativeTime(a)} width={150} />,
  };

  let rejectedAtColAll: Col = {
    name: "撞库时间",
    key: "rejectedAt",
    colSort: 11,
    width: 150,
    hideInCreate: true,
    showInFilter: false,
    defaultSortOrder: ["reject"].includes(props.type) ? "descend" : undefined,
    type: ColType.DATE_RANGE,
    render: (a: any) => <TextCell text={formatRelativeTime(a)} width={150} />,
  };

  let scoreCol = {
    name: "分值",
    key: "score",
    hideInCreate: props.type != "all",
    type: ColType.NUMBER,
  };
  let favCol = {
    name: "标记",
    key: "fav",
    colSort: 0,
    width: 40,
    type: ColType.STRING,
    hideInCreate: true,
    render: (a: any, row: any) => (
      <FavButton defaultValue={a} leadId={row.id} crudApi={crudApi} />
    ),
  };

  let statCol: Col = {
    name: "统计项",
    key: "statType",
    colFilterSort: 0,
    showInFilter: true,
    hideInCreate: true,
    hideInList: true,
    type: ColType.SELECT,
    getOptions: () => Promise.resolve(getLeadStatItemOpt()),
  };
  let statMyCol: Col = {
    name: "统计项",
    key: "statType",
    colFilterSort: 0,
    showInFilter: true,
    hideInCreate: true,
    hideInList: true,
    type: ColType.SELECT,
    getOptions: () => Promise.resolve(getMyLeadStatItemOpt()),
  };

  if (props.type == "all") {
    cols = cols.concat([
      //refOrderNoCol,
      //scoreCol,
      //costCol,
      rootTeamCol,
      teamIdCol,
      teamNameCol,
      saleIdCol,
      saleNameCol,
      // assignStatusCol,
      sourceCol,
      rejectedAtColAll,
      assignAtColAll,
      sendToPoolAtCol,
      lastContactAt,
    ]);
    cols.forEach((c) => {
      if (c.key == "createdAt") {
        c.colSort = 0;
        c.defaultSortOrder = "descend";
      } else if (c.defaultSortOrder != undefined) {
        c.defaultSortOrder = false;
      }
      if (c.key == "source") {
        c.colSort = 0;
      }
    });
  } else if (props.type == "new" || props.type == "fav") {
    cols.unshift(statCol);
    cols = cols.concat([
      rootTeamCol,
      assignAtCol,
      saleNameCol,
      lastContactAt,
      poolCountDownCol,
      saleIdCol,
      teamIdCol,
      rejectedAtColAll,
    ]);
    cols.unshift(favCol);
  } else if (props.type == "my") {
    cols.unshift(statMyCol);
    cols = cols.concat([
      rootTeamCol,
      assignAtCol,
      saleNameCol,
      lastContactAt,
      poolCountDownCol,
      saleIdCol,
      teamIdCol,
      rejectedAtColAll,
    ]);
    cols.unshift(favCol);
  } else if (props.type == "team") {
    cols.unshift(statCol);
    cols = cols.concat([
      saleIdCol,
      saleNameCol,
      sourceCol,
      sourceTeamCol,
      assignAtCol,
      lastContactAt,
      poolCountDownCol,
      teamIdCol,
      rejectedAtColAll,
    ]);
  } else if (props.type == "pool" || props.type == "waste" || props.type == "cancellation") {
    cols = cols.concat([sourceCol,sendToPoolAtCol, lastContactAt, rejectedAtColAll]);
  } else if (props.type == "reject") {
    initFilterValues = {
      rejectedAt: [startDateStr, nowDateStr],
    };
    initParams = {
      rejectedAt: startDateStr + "," + nowDateStr,
    };
    cols = cols.concat([rejectedAtCol, lastContactAt]);
  }

  const [lead, setLead] = useState(undefined as undefined | Lead);

  const handleCloseModal = () => {
    crudApi?.refresh();
    setLead(undefined);
    // HOT FIX
    document.body.style.overflow = "auto";
    document.body.style.width = "auto";
  };
  const handleAssignButtonClick = (a: any, rows: any) => {
    if (!rows || rows.length == 0) {
      Toast.info("请选择客户");
      return;
    }
    setSelectedLeads(rows);
    setShowAssignModal(true);
    let strIds = localStorage.getItem("assignToIds");
    if (strIds) {
      apiClient
        .request("/users/removeLeaveUserId", "GET", {
          ids: JSON.parse(strIds),
        })
        .then((resp: any) => {
          setSelectedMembers(resp.data);
        });
    }
  };
  const handleTransAssignButtonClick = (a: any, rows: any) => {
    if (!rows || rows.length == 0) {
      Toast.info("请选择客户");
      return;
    }
    setSelectedLeads(rows);
    setShowTransAssignModal(true);
    apiClient.getTeamCityAsOpts().then((opts) => setTeamCitys(opts));
  };
  const handlePoolButtonClick = (a: any, rows: any) => {
    if (!rows || rows.length == 0) {
      Toast.info("请选择客户");
      return;
    }
    setSelectedLeads(rows);
    setShowPoolModal(true);
  };

  const handleWasteButtonClick = (a: any, rows: any) => {
    if (!rows || rows.length == 0) {
      Toast.info("请选择客户");
      return;
    }
    setSelectedLeads(rows);
    setShowWasteModal(true);
  };

    const handleCancellationButtonClick = (a: any, rows: any) => {
    if (!rows || rows.length == 0) {
      Toast.info("请选择客户");
      return;
    }
    setSelectedLeads(rows);
    setShowCancellationModal(true);
  };

  const handleDeleteButtonClick = (a: any, rows: any) => {
    if (!rows || rows.length == 0) {
      Toast.info("请选择客户");
      return;
    }
    setSelectedLeads(rows);
    setShowDeleteModal(true);
  };

  const actions: CrudAction[] = [];
  const assignAction: CrudAction = {
    name: "分配客户",
    action: handleAssignButtonClick,
  };
  const transAssignAction: CrudAction = {
    name: "转移流量池",
    action: handleTransAssignButtonClick,
  };
  const sendToPoolAction: CrudAction = {
    name: "送回公共池",
    action: handlePoolButtonClick,
  };

  const sendToWasteAction: CrudAction = {
    name: "送回废物池",
    action: handleWasteButtonClick,
  };
    const sendToCancellationAction: CrudAction = {
    name: "退单",
    action: handleCancellationButtonClick,
  };

  const deleteAction: CrudAction = {
    name: "删除客户",
    action: handleDeleteButtonClick,
  };

  const sendFindLeadAction: CrudAction = {
    name: "找客户",
    action: () => {
      setShowFindModal(true);
    },
  };
  // const handleImportClick = () => {
  //   let input = document.createElement("input");
  //   input.type = "file";
  //   input.accept = ".xlsx";
  //   input.onchange = async () => {
  //     let file = input.files![0];
  //     if (!file) {
  //       return;
  //     }
  //     setImporting(true);
  //     try {
  //       const resp = await apiClient.request<number>(
  //         "/leads/import?leadType=NEW",
  //         "POST",
  //         undefined,
  //         undefined,
  //         file
  //       );
  //       Toast.info(`导入 ${resp.data} 个客户`);
  //       setImporting(false);

  //       crudApi?.refresh();
  //       //我的客户需要刷新
  //       localStorage.setItem("new-refresh", "true");
  //       //  publish 发布消息 消息名为：name 内容为：
  //       pubsub.publish("refreshMenuCount", "");
  //     } catch (e) {
  //       setImporting(false);
  //     }
  //   };
  //   input.click();
  // };

  // const handleImportMyClick = () => {
  //   let input = document.createElement("input");
  //   input.type = "file";
  //   input.accept = ".xlsx";
  //   input.onchange = async () => {
  //     let file = input.files![0];
  //     if (!file) {
  //       return;
  //     }
  //     setImporting(true);
  //     try {
  //       const resp = await apiClient.request<number>(
  //         "/leads/import?leadType=MY",
  //         "POST",
  //         undefined,
  //         undefined,
  //         file
  //       );
  //       Toast.info(`导入 ${resp.data} 个客户`);
  //       setImporting(false);

  //       crudApi?.refresh();
  //       //我的客户需要刷新
  //       localStorage.setItem("new-refresh", "true");
  //       //  publish 发布消息 消息名为：name 内容为：
  //       pubsub.publish("refreshMenuCount", "");
  //     } catch (e) {
  //       setImporting(false);
  //     }
  //   };
  //   input.click();
  // };

  // const importLeadsAction: CrudAction = {
  //   name: "导入新客户",
  //   action: handleImportClick,
  //   loading: importing,
  //   icon: <IconCloudUploadStroked />,
  // };
  // const importMyLeadsAction: CrudAction = {
  //   name: "导入再分配客户",
  //   action: handleImportMyClick,
  //   loading: importing,
  //   icon: <IconCloudUploadStroked />,
  // };

  const newImportLeadsAction: CrudAction = {
    name: "导入新客户",
    action: () => {
      setImportLeadType("NEW");
      setIsImporting(false);
      setFile(null);
      setTaskId(null);
      setVisibleErrors(false);
      setProgress(0);
      setStatus("pending");
      setImportData({
        total: 0,
        processed: 0,
        success: 0,
        fail: 0,
        processing: "",
        errors: [],
        assignFail: 0,
        assignSuccess: 0,
      });
      setShowImportModal(true);
      console.log("newImportLeadsAction ", importLeadType);
    },
    loading: importing,
    icon: <IconCloudUploadStroked />,
  };
  const newImportMyLeadsAction: CrudAction = {
    name: "导入再分配客户",
    action: () => {
      setImportLeadType("MY");
      setIsImporting(false);
      setFile(null);
      setTaskId(null);
      setVisibleErrors(false);
      setProgress(0);
      setStatus("pending");
      setImportData({
        total: 0,
        processed: 0,
        success: 0,
        fail: 0,
        processing: "",
        errors: [],
        assignFail: 0,
        assignSuccess: 0,
      });
      setShowImportModal(true);
      console.log("newImportMyLeadsAction ", importLeadType);
    },
    loading: importing,
    icon: <IconCloudUploadStroked />,
  };
  const handleTemplateClick = () => {
    window.open(siteInfo?.importTemplateUrl, "_blank");
  };
  const importTemplateAction: CrudAction = {
    name: "下载导入模板",
    action: handleTemplateClick,
    loading: importing,
  };

  // const handleImportFavClick = () => {
  //   let input = document.createElement("input");
  //   input.type = "file";
  //   input.accept = ".xlsx";
  //   input.onchange = async () => {
  //     let file = input.files![0];
  //     if (!file) {
  //       return;
  //     }
  //     setImporting(true);
  //     try {
  //       const resp = await apiClient.request<number>(
  //         "/leads/importFav",
  //         "POST",
  //         undefined,
  //         undefined,
  //         file
  //       );
  //       showNoAutoCloseToast(`导入结果： ${resp.data} `);
  //       setImporting(false);

  //       crudApi?.refresh();
  //       //  publish 发布消息 消息名为：name 内容为：
  //       pubsub.publish("refreshMenuCount", "");
  //     } catch (e) {
  //       setImporting(false);
  //     }
  //   };
  //   input.click();
  // };

  // const importFavLeadsAction: CrudAction = {
  //   name: "导入分配客户",
  //   action: handleImportFavClick,
  //   loading: importing,
  //   icon: <IconCloudUploadStroked />,
  // };
  // const handleFavTemplateClick = () => {
  //   window.open(siteInfo?.siteUrl + "/file/importFav.xlsx", "_blank");
  // };
  // const importFavTemplateAction: CrudAction = {
  //   name: "下载导入分配模板",
  //   action: handleFavTemplateClick,
  //   loading: importing,
  // };

  const [toastId, setToastId] = useState("");
  const showNoAutoCloseToast = (msg: string) => {
    if (toastId) {
      return;
    }
    let opts = {
      content: msg,
      duration: 30,
      onClose: hideNoAutoCloseToast,
    };
    let id = Toast.info(opts);
    setToastId(id);
  };
  const hideNoAutoCloseToast = () => {
    Toast.close(toastId);
    setToastId("");
  };

  const handleAssignClick = async () => {
    setAssignSaving(true);
    try {
      await assignFormApi!.validate();
      await apiClient.request(
        "/leads/assign",
        "POST",
        undefined,
        assignFormApi!.getValues()
      );
      //保存上次分配用户
      let assignToIds = assignFormApi!.getValue("assignToIds");
      localStorage.setItem("assignToIds", JSON.stringify(assignToIds));

      setSelectedLeads([]);
      crudApi?.refresh();
      //我的客户需要刷新
      localStorage.setItem("my-refresh", "true");
      localStorage.setItem("new-refresh", "true");
      localStorage.setItem("all-refresh", "true");
      setAssignSaving(false);
      setShowAssignModal(false);

      //  publish 发布消息 消息名为：name 内容为：
      pubsub.publish("refreshMenuCount", "");
    } catch (e) {
      setAssignSaving(false);
    }
  };

  const handleTransAssignClick = async () => {
    setAssignSaving(true);
    try {
      await transAssignFormApi!.validate();
      let params = {
        ...transAssignFormApi!.getValues(),
        assignToIds: [0],
        assignLeadType: "transToNewCity",
      };
      await apiClient.request("/leads/assign", "POST", undefined, params);

      setSelectedLeads([]);
      crudApi?.refresh();
      //我的客户需要刷新
      localStorage.setItem("my-refresh", "true");
      localStorage.setItem("new-refresh", "true");
      localStorage.setItem("all-refresh", "true");
      setAssignSaving(false);
      setShowTransAssignModal(false);

      //  publish 发布消息 消息名为：name 内容为：
      pubsub.publish("refreshMenuCount", "");
    } catch (e) {
      setAssignSaving(false);
    }
  };
  const handlePoolClick = async () => {
    setPoolSaving(true);
    try {
      await poolFormApi!.validate();
      await apiClient.request(
        "/leads/pool",
        "POST",
        undefined,
        poolFormApi!.getValues()
      );

      crudApi?.refresh();
      //公共池需要刷新
      localStorage.setItem("pool-refresh", "true");
      setPoolSaving(false);
      setShowPoolModal(false);
      setSelectedLeads([]);
      //  publish 发布消息 消息名为：name 内容为：
      pubsub.publish("refreshMenuCount", "");
    } catch (e) {
      console.log(e);
      setPoolSaving(false);
    }
  };

  const handleWasteClick = async () => {
    setWasteSaving(true);
    try {
      await wasteFormApi!.validate();
      await apiClient.request(
        "/leads/waste",
        "POST",
        undefined,
        wasteFormApi!.getValues()
      );

      crudApi?.refresh();
      //废物池需要刷新
      localStorage.setItem("waste-refresh", "true");
      setWasteSaving(false);
      setShowWasteModal(false);
      setSelectedLeads([]);
      //  publish 发布消息 消息名为：name 内容为：
      pubsub.publish("refreshMenuCount", "");
    } catch (e) {
      console.log(e);
      setWasteSaving(false);
    }
  };

   const handleCancellationClick = async () => {
    setCancellationSaving(true);
    try {
      await cancellationFormApi!.validate();
      await apiClient.request(
        "/leads/cancellation",
        "POST",
        undefined,
        cancellationFormApi!.getValues()
      );

      crudApi?.refresh();
      //废物池需要刷新
      localStorage.setItem("cancellation-refresh", "true");
      setCancellationSaving(false);
      setShowCancellationModal(false);
      setSelectedLeads([]);
      //  publish 发布消息 消息名为：name 内容为：
      pubsub.publish("refreshMenuCount", "");
    } catch (e) {
      console.log(e);
      setCancellationSaving(false);
    }
  };

  const handleDeleteClick = async () => {
    setWasteSaving(true);
    try {
      await deleteFormApi!.validate();
      await apiClient.request(
        "/leads/delete",
        "POST",
        undefined,
        deleteFormApi!.getValues()
      );

      crudApi?.refresh();
      setWasteSaving(false);
      setShowDeleteModal(false);
      setSelectedLeads([]);
      //  publish 发布消息 消息名为：name 内容为：
      pubsub.publish("refreshMenuCount", "");
    } catch (e) {
      console.log(e);
      setWasteSaving(false);
    }
  };

  const handleFindClick = async () => {
    await findFormApi?.validate();
    try {
      const lead = await apiClient.findLeadByMobile(
        findFormApi?.getValue("mobile")
      );
      setFinding(false);
      if (!lead) {
        Toast.warning("没有找到客户，请翻页");
        return;
      }
      setLead(lead);
    } catch (e) {
      console.log(e);
      setFinding(false);
    }
  };

  const handleFavClick = async () => {
    if (saving) {
      return;
    }
    Modal.confirm({
      title: "是否确认设置为重要客户?",
      content: "",
      onOk: async () => {
        setSaving(true);
        try {
          await apiClient.request("/leads/fav", "POST", undefined, {
            leadId: lead?.id,
            fav: true,
          });
          Toast.info("已标记为重要客户");
          setSaving(false);

          //  publish 发布消息 消息名为：name 内容为：
          pubsub.publish("refreshMenuCount", "");
        } catch (e) {
          setSaving(false);
        }
      },
    });
  };

  const handleUnFavClick = async () => {
    if (saving) {
      return;
    }
    Modal.confirm({
      title: "是否确认设置为普通客户?",
      content: "",
      onOk: async () => {
        setSaving(true);
        try {
          await apiClient.request("/leads/fav", "POST", undefined, {
            leadId: lead?.id,
            fav: false,
          });
          Toast.info("已标记为普通客户");
          setSaving(false);

          //  publish 发布消息 消息名为：name 内容为：
          pubsub.publish("refreshMenuCount", "");
        } catch (e) {
          setSaving(false);
        }
      },
    });
  };

  const setFavLeadAction: CrudAction = {
    name: "设为重要客户",
    action: handleFavClick,
  };

  const setUnFavLeadAction: CrudAction = {
    name: "设为普通客户",
    action: handleUnFavClick,
  };

  let refreshLeadInterval: any = useRef();
  useEffect(() => {
    if(props.type == "all" ||
          props.type == "new" ||
          props.type == "fav" ||
          props.type == "my"){
            setCanCreateLead(true);

    } else {
      setCanCreateLead(false);
    }
    if ("兰州" == city) {
      setPageSize(30);
      if (role == "sale" || role == "student") {
          setCanCreateLead(false);
      }
    } else {
      setPageSize(50);
    }
    if (
      props.type == "new" ||
      props.type == "my" ||
      props.type == "team" ||
      props.type == "fav"
    ) {
      //queryLeadStatCount();
    }

    localStorage.setItem(props.type + "-refresh", "false");
    let currUsername;
    if (role == "op_manager" || role == "monitor") {
      currUsername = "root";
    } else {
      currUsername = username;
    }
    apiClient
      .getTeamMemberTreeAsOptsOfAny(currUsername)
      .then((opts) => setTeamMembersTree(opts));

    return () => {
      console.log("离开页面------------");
      // 清除定时器
      clearInterval(refreshLeadInterval.current);
    };
  }, []);

  useEffect(() => {
    //刷新统计
    initLeadStatCountData(crudApi, filterFormApi);
  }, [statDataObj]);

  useEffect(() => {
    selectedMembersRef.current = selectedMembers;
  }, [selectedMembers]);

  //team、pool不刷新
  if (
    activiRoute == props.router &&
    props.type != "team" &&
    props.type != "pool" &&
    props.type != "waste" &&
    props.type != "cancellation"
  ) {
    let refreshMark = localStorage.getItem(props.type + "-refresh");
    if (refreshMark == "true") {
      crudApi?.refresh();
      localStorage.setItem(props.type + "-refresh", "false");
      console.log("tab到当前页面刷新列表");
    }
  }

  const initRefreshInterval = (rsApi: CrudApi) => {
    if (role != "sale" && (props.type == "new" || props.type == "my")) {
      //先销毁
      clearInterval(refreshLeadInterval.current);
      //开启定时器
      refreshLeadInterval.current = setInterval(() => refreshLead(), 15000);
      let refreshLead = async () => {
        //team、fav不刷新
        if (
          props.type != "team" &&
          props.type != "pool" &&
          props.type != "waste" &&
          props.type != "fav" &&
          props.type != "cancellation"

        ) {
          let refreshMark = localStorage.getItem(props.type + "-refresh");
          if (refreshMark == "true") {
            rsApi?.refresh();
            localStorage.setItem(props.type + "-refresh", "false");
            console.log(
              props.router + "定时器：刷新客户列表：",
              new Date().toLocaleTimeString()
            );
          }
        }
      };
    }
  };

  //列的展示顺序排序
  cols.sort((a, b) => {
    if (a.colSort == undefined && b.colSort == undefined) {
      return 0;
    } else if (b.colSort == undefined) {
      return -1;
    } else if (a.colSort == undefined) {
      return 1;
    } else {
      return a.colSort - b.colSort;
    }
  });
  //------------------------------------------------按钮控制------------------------------------------------------------------
  let select = false;
  if (props.type == "all") {
    //actions.push(importLeadsAction);
    //actions.push(importMyLeadsAction);
    actions.push(newImportLeadsAction);
    actions.push(newImportMyLeadsAction);
    actions.push(importTemplateAction);
    //主管及以上
    if (role != "sale") {
      actions.push(assignAction);
      actions.push(sendToWasteAction);
      actions.push(sendToCancellationAction);
    }
    if (role == "op_manager") {
      actions.push(sendToPoolAction);
      actions.push(transAssignAction);
    }

    select = true;
  }

  if (props.type == "pool") {
    actions.push(sendToWasteAction);
    actions.push(assignAction);
    actions.push(sendToCancellationAction);
    select = true;
  }
  if (props.type == "reject") {
    actions.push(sendToWasteAction);
    actions.push(assignAction);
    actions.push(sendToCancellationAction);
    select = true;
  }
  if (props.type == "waste") {
    actions.push(assignAction);
    if (role == "op_manager") {
      actions.push(deleteAction);
    }
    select = true;
  }

  if (props.type == "new") {
    actions.push(sendToPoolAction);
    //主管及以上
    if (role != "sale") {
      actions.push(assignAction);
      actions.push(sendToCancellationAction);
    }
    select = true;
  }

  if (props.type == "fav") {
    actions.push(sendToPoolAction);
    select = true;
  }

  if (props.type == "my") {
    actions.push(sendToPoolAction);
    //主管及以上
    if (role != "sale") {
      actions.push(assignAction);
      actions.push(sendToCancellationAction);
    }
    select = true;
  }

  if (props.type == "team") {
    if (role != "sale") {
      actions.push(sendToPoolAction);
      actions.push(assignAction);
      actions.push(sendToWasteAction);
      actions.push(sendToCancellationAction);
    }
    select = true;
  }

  //刷新列表
  const refreshLeadCurd = () => {
    crudApi?.refresh();
  };

  //打开详情
  const detailAction = (a: Lead, all: Lead[] | undefined) => {
    setLead(a);
    let ids: any = [];
    if (all) {
      ids = all.map((i) => i.id);
      setLeadIds(ids);
    }
    const w = window.open("about:blank");
    if (w != null) {
      const data = {
        id: a.id,
        ids: [],
        queryParams: crudApi?.getQueryParams(),
      };
      // w.location.href =
      //   "/#/leadDetailNew?data=" + encodeURIComponent(JSON.stringify(data));
       w.location.href =
        "/#/leadDetailNew?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

  const queryLeadStatCount = async (data: any) => {
    setStatLoading(true);
    let params = {
      type: props.type,
      ...data,
    };
    console.log("统计报表查询参数：", params);
    if (props.type == "my") {
      apiClient.assignNotContactMyLeadCount(params).then((resp) => {
        setStatLoading(false);
        setStatDataObj(resp.data);
        // initLeadStatCountData(resp.data, crudApi, filterFormApi);
      });
    } else {
      apiClient.assignNotContactLeadCount(params).then((resp) => {
        setStatLoading(false);
        setStatDataObj(resp.data);
        //initLeadStatCountData(resp.data, crudApi, filterFormApi);
      });
    }
  };

  const initLeadStatCountData = async (
    rsApi?: CrudApi,
    filterFormApi?: FormApi
  ) => {
    console.log("统计报表返回数据：", statDataObj);
    if (statDataObj.length == 0) {
      return;
    }

    if (props.type == "my") {
      const data = [
        { key: "", value: "名下" },
        {
          key: "总数",
          value: (
            <Button
              theme="borderless"
              type="primary"
              onClick={() =>
                handleStatNumClick("statMyAll", rsApi, filterFormApi)
              }
            >
              {statDataObj[0].assignCount}
            </Button>
          ),
        },
        {
          key: "0星数",
          value: (
            <Button
              theme="borderless"
              type="primary"
              onClick={() =>
                handleStatNumClick("statMyAll0", rsApi, filterFormApi)
              }
            >
              {statDataObj[0].star0}
            </Button>
          ),
        },
        {
          key: "0星占比",
          value: formatPercent(statDataObj[0].starRate0),
        },
        { key: "", value: "蓝色(未跟进)" },
        {
          key: "总数",
          value: (
            <Button
              theme="borderless"
              type="primary"
              onClick={() =>
                handleStatNumClick("statMyNotContactAll", rsApi, filterFormApi)
              }
            >
              {statDataObj[1].assignCount}
            </Button>
          ),
        },
        {
          key: "0星数",
          value: (
            <Button
              theme="borderless"
              type="primary"
              onClick={() =>
                handleStatNumClick("statMyNotContactAll0", rsApi, filterFormApi)
              }
            >
              {statDataObj[1].star0}
            </Button>
          ),
        },
        {
          key: "3星以上",
          value: (
            <Button
              theme="borderless"
              type="primary"
              onClick={() =>
                handleStatNumClick("statMyNotContactAll3", rsApi, filterFormApi)
              }
            >
              {statDataObj[1].starGe3}
            </Button>
          ),
        },
      ];

      setStatData(data);
    } else {
      const data = [
        { key: "", value: "今日" },
        {
          key: "总数",
          value: (
            <Button
              theme="borderless"
              type="primary"
              onClick={() =>
                handleStatNumClick("statToday", rsApi, filterFormApi)
              }
            >
              {statDataObj[0].assignCount}
            </Button>
          ),
        },
        {
          key: "0星数",
          value: (
            <Button
              theme="borderless"
              type="primary"
              onClick={() =>
                handleStatNumClick("statToday0", rsApi, filterFormApi)
              }
            >
              {statDataObj[0].star0}
            </Button>
          ),
        },
        {
          key: "0星占比",
          value: formatPercent(statDataObj[0].starRate0),
        },
        { key: "", value: "<=3天" },
        {
          key: "总数",
          value: (
            <Button
              theme="borderless"
              type="primary"
              onClick={() =>
                handleStatNumClick("statThreeDay", rsApi, filterFormApi)
              }
            >
              {statDataObj[1].assignCount}
            </Button>
          ),
        },
        {
          key: "0星数",
          value: (
            <Button
              theme="borderless"
              type="primary"
              onClick={() =>
                handleStatNumClick("statThreeDay0", rsApi, filterFormApi)
              }
            >
              {statDataObj[1].star0}
            </Button>
          ),
        },
        {
          key: "3星以上",
          value: (
            <Button
              theme="borderless"
              type="primary"
              onClick={() =>
                handleStatNumClick("statThreeDay3", rsApi, filterFormApi)
              }
            >
              {statDataObj[1].starGe3}
            </Button>
          ),
        },
        // { key: "", value: "<=5天" },
        // {
        //   key: "总数",
        //   value: (
        //     <Button
        //       theme="borderless"
        //       type="primary"
        //       onClick={() =>
        //         handleStatNumClick("statSevenDay", rsApi, filterFormApi)
        //       }
        //     >
        //       {statDataObj[2].assignCount}
        //     </Button>
        //   ),
        // },
        // {
        //   key: "0星数",
        //   value: (
        //     <Button
        //       theme="borderless"
        //       type="primary"
        //       onClick={() =>
        //         handleStatNumClick("statSevenDay0", rsApi, filterFormApi)
        //       }
        //     >
        //       {statDataObj[2].star0}
        //     </Button>
        //   ),
        // },
        // {
        //   key: "3星以上",
        //   value: (
        //     <Button
        //       theme="borderless"
        //       type="primary"
        //       onClick={() =>
        //         handleStatNumClick("statSevenDay3", rsApi, filterFormApi)
        //       }
        //     >
        //       {statDataObj[2].starGe3}
        //     </Button>
        //   ),
        // },
      ];

      setStatData(data);
    }
  };

  const handleStatNumClick = async (
    statType: string,
    rsApi?: CrudApi,
    filterFormApi1?: FormApi
  ) => {
    filterFormApi1?.setValue("statType", statType);
    rsApi?.refresh();
  };

  const userStat = () => {
    const style = {
      boxShadow: "var(--semi-shadow-elevated)",
      backgroundColor: "var(--semi-color-bg-2)",
      borderRadius: "4px",
      padding: "10px",
      margin: "auto",
    };
    return (
      <div style={{ display: "flex", width: "100%", margin: "5px" }}>
        <Descriptions data={statData} row style={style} />
      </div>
    );
  };

  const renderLabel = (label: any, item: any) => (
    <div
      style={{
        padding: "6px 8px",
        lineHeight: 1.0,
      }}
    >
      <div
        style={{
          fontWeight: 500,
          color: "var(--semi-color-text-0)",
          fontSize: 14,
        }}
      >
        {label}
        <span
          style={{
            fontSize: 12,
            color: "var(--semi-color-text-2)",
            marginLeft: 10,
          }}
        >
          {item.labelSubText}
        </span>
      </div>
    </div>
  );

  return (
    <div>
      {/* <LeadDetail
        onCancel={handleCloseModal}
        onOk={handleCloseModal}
        leadId={lead?.id}
        leadIds={leadIds}
        onSentToPool={handleCloseModal}
      /> */}

      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        style={{ width: 1200, height: 750 }}
        headerStyle={{
          flexShrink: 0, // 关键属性 2：固定标题
          borderBottom: "1px solid var(--semi-color-border)",
        }}
        bodyStyle={{
          overflow: "auto", // 关键属性 3：启用内容滚动
          flex: 1,
        }}
        footer={null}
        title="导入客户"
        visible={showImportModal}
        okText="确定"
        onCancel={() => setShowImportModal(false)}
      >
        <div className="import-container">
          <div className="file-upload-container">
            <div>
              <input
                id="file-input"
                type="file"
                accept=".xlsx,.xls"
                onChange={handleFileChange}
                disabled={isImporting}
                style={{ display: "none" }}
              />
              <label htmlFor="file-input" className="file-upload-label">
                选择Excel文件
              </label>
              {file && <span className="file-name">{file.name}</span>}
            </div>

            <Button
              theme="solid"
              onClick={startImport}
              loading={isImporting}
              disabled={!file || isImporting}
            >
              {isImporting ? "导入中..." : "开始导入"}
            </Button>
          </div>

          {taskId && (
            <div className="progress-section">
              <div className="task-id">
                <span className="task-id-label">任务ID:</span>
                <span>{taskId}</span>
                <span className="task-id-label" style={{ marginLeft: 20 }}>
                  处理进展:
                </span>
                <span
                  style={{ fontSize: "16px", fontWeight: "bold", color: "red" }}
                >
                  {importData.processing}
                </span>
              </div>

              <Progress
                percent={progress}
                strokeWidth={12}
                style={{ height: "15px" }}
                aria-label="disk usage"
                // status={
                //   status === "completed"
                //     ? "success"
                //     : status === "failed"
                //     ? "error"
                //     : "normal"
                // }
              />

              <div className="stats-grid">
                <StatCard
                  title="总条数"
                  value={importData.total}
                  type="normal"
                />

                <StatCard
                  title="导入成功"
                  value={importData.success}
                  type="success"
                />
                <StatCard
                  title="导入失败"
                  value={importData.fail}
                  type="error"
                />
                <StatCard
                  title="分配成功"
                  value={importData.assignSuccess}
                  type="success"
                />
                <StatCard
                  title="分配失败"
                  value={importData.assignFail}
                  type="error"
                />
              </div>

              {importData.fail > 0 && (
                <div className="errors-section">
                  <div className="errors-header">
                    <h3 className="errors-title">
                      错误详情
                      <span className="error-badge">{importData.fail}</span>
                    </h3>
                    <Button
                      theme="light"
                      onClick={() => setVisibleErrors(!visibleErrors)}
                    >
                      {visibleErrors ? "隐藏错误" : "查看错误"}
                    </Button>
                  </div>

                  {visibleErrors && (
                    <div className="error-table">
                      {/* <Table
                    columns={errorColumns}
                    dataSource={importData.errors}
                    pagination={{ pageSize: 5 }}
                    rowKey="rowIndex"
                    rowClassName={() => "error-row-highlight"}
                  /> */}
                      <LeadImportLogDetail batchNo={taskId} importResult={0} />
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </Modal>

      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        style={{ width: 1600, height: 650 }}
        title="分配客户"
        visible={showAssignModal}
        okText="分配"
        confirmLoading={assignSaving}
        onOk={handleAssignClick}
        onCancel={() => setShowAssignModal(false)}
      >
        <Form getFormApi={(formApi) => setAssignFormApi(formApi)}>
          <Form.TreeSelect
            placeholder="请选择分配给谁"
            rules={[{ required: true, message: "请填写" }]}
            style={{ width: "100%" }}
            field="assignToIds"
            label="销售"
            //defaultExpandAll
            checkRelation="unRelated"
            leafOnly
            multiple
            treeData={teamMembersTree}
            initValue={selectedMembersRef.current}
            filterTreeNode
            showFilteredOnly={true}
            searchPlaceholder="请输入关键字开始搜索"
            renderLabel={renderLabel}
            autoAdjustOverflow={false}
            virtualize={{
              itemSize: 28,
              height: 400,
            }}
          ></Form.TreeSelect>
          <Form.Select
            rules={[{ required: true, message: "请填写" }]}
            disabled
            initValue={selectedLeads.map((l) => l.id)}
            style={{ width: "100%" }}
            multiple
            field="leadIds"
            label="客户"
          >
            {selectedLeads.map((l) => (
              <Form.Select.Option key={l.id + ""} value={l.id}>
                {l.name}
              </Form.Select.Option>
            ))}
          </Form.Select>

          {(role == "root" || role == "op_manager" || role == "monitor") && (
            <Form.Select
              rules={[{ required: true, message: "请填写" }]}
              initValue="my"
              style={{ width: "100%" }}
              field="assignLeadType"
              label={{
                text: "分配客户类型",
                extra: (
                  <Tooltip
                    style={{ maxWidth: 400 }}
                    content={"选择新客户，客户会作为新客户分配"}
                  >
                    <IconHelpCircle
                      style={{
                        color: "#E91E63",
                      }}
                    />
                  </Tooltip>
                ),
              }}
            >
              <Form.Select.Option key="my" value="my">
                再分配客户
              </Form.Select.Option>
              <Form.Select.Option key="new" value="new">
                新客户
              </Form.Select.Option>
            </Form.Select>
          )}
        </Form>
      </Modal>

      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        style={{ width: 600, height: 600 }}
        title="转移流量池"
        visible={showTransAssignModal}
        okText="转移"
        confirmLoading={assignSaving}
        onOk={handleTransAssignClick}
        onCancel={() => setShowTransAssignModal(false)}
      >
        <Form getFormApi={(formApi) => setTransAssignFormApi(formApi)}>
          <Form.Select
            rules={[{ required: true, message: "请填写" }]}
            disabled
            initValue={selectedLeads.map((l) => l.id)}
            style={{ width: "100%" }}
            multiple
            field="leadIds"
            label="客户"
          >
            {selectedLeads.map((l) => (
              <Form.Select.Option key={l.id + ""} value={l.id}>
                {l.name}
              </Form.Select.Option>
            ))}
          </Form.Select>

          <Form.Select
            rules={[{ required: true, message: "请填写" }]}
            style={{ width: "100%" }}
            field="assignToNewCity"
            label={{
              text: "流量池",
              extra: (
                <Tooltip
                  style={{ maxWidth: 400 }}
                  content={"选择流量池，客户会作为新客户分配到选择的流量池"}
                >
                  <IconHelpCircle
                    style={{
                      color: "#E91E63",
                    }}
                  />
                </Tooltip>
              ),
            }}
          >
            {teamCitys.map((l) => (
              <Form.Select.Option key={l.id + ""} value={l.value}>
                {l.label}
              </Form.Select.Option>
            ))}
          </Form.Select>
        </Form>
      </Modal>

      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        title="送回公共池"
        visible={showPoolModal}
        okText="送回公共池"
        confirmLoading={poolSaving}
        onOk={handlePoolClick}
        onCancel={() => setShowPoolModal(false)}
      >
        <Form getFormApi={(formApi) => setPoolFormApi(formApi)}>
          <Form.Select
            rules={[{ required: true, message: "请填写" }]}
            disabled
            initValue={selectedLeads.map((l) => l.id)}
            style={{ width: "100%" }}
            multiple
            field="leadIds"
            label="客户"
          >
            {selectedLeads.map((l) => (
              <Form.Select.Option key={l.id + ""} value={l.id}>
                {l.name}
              </Form.Select.Option>
            ))}
          </Form.Select>
        </Form>
      </Modal>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        title="送回废物池"
        visible={showWasteModal}
        okText="送回废物池"
        confirmLoading={wasteSaving}
        onOk={handleWasteClick}
        onCancel={() => setShowWasteModal(false)}
      >
        <Form getFormApi={(formApi) => setWasteFormApi(formApi)}>
          <Form.Select
            rules={[{ required: true, message: "请填写" }]}
            disabled
            initValue={selectedLeads.map((l) => l.id)}
            style={{ width: "100%" }}
            multiple
            field="leadIds"
            label="客户"
          >
            {selectedLeads.map((l) => (
              <Form.Select.Option key={l.id + ""} value={l.id}>
                {l.name}
              </Form.Select.Option>
            ))}
          </Form.Select>
        </Form>
      </Modal>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        title="退单"
        visible={showCancellationModal}
        okText="退单"
        confirmLoading={cancellationSaving}
        onOk={handleCancellationClick}
        onCancel={() => setShowCancellationModal(false)}
      >
        <Form getFormApi={(formApi) => setCancellationFormApi(formApi)}>
          <Form.Select
            rules={[{ required: true, message: "请填写" }]}
            disabled
            initValue={selectedLeads.map((l) => l.id)}
            style={{ width: "100%" }}
            multiple
            field="leadIds"
            label="客户"
          >
            {selectedLeads.map((l) => (
              <Form.Select.Option key={l.id + ""} value={l.id}>
                {l.name}
              </Form.Select.Option>
            ))}
          </Form.Select>
        </Form>
      </Modal>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        title="删除客户"
        visible={showDeleteModal}
        okText="删除客户"
        confirmLoading={wasteSaving}
        onOk={handleDeleteClick}
        onCancel={() => setShowDeleteModal(false)}
      >
        <Form getFormApi={(formApi) => setDeleteFormApi(formApi)}>
          <Form.Select
            rules={[{ required: true, message: "请填写" }]}
            disabled
            initValue={selectedLeads.map((l) => l.id)}
            style={{ width: "100%" }}
            multiple
            field="leadIds"
            label="客户"
          >
            {selectedLeads.map((l) => (
              <Form.Select.Option key={l.id + ""} value={l.id}>
                {l.name}
              </Form.Select.Option>
            ))}
          </Form.Select>
        </Form>
      </Modal>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        title="查找客户"
        visible={showFindModal}
        okText="查找"
        confirmLoading={finding}
        onOk={handleFindClick}
        onCancel={() => setShowFindModal(false)}
      >
        <Form getFormApi={(formApi) => setFindFormApi(formApi)}>
          <Form.Input
            rules={[{ required: true, message: "请填写" }]}
            style={{ width: "100%" }}
            multiple
            field="mobile"
            label="手机号"
          />
        </Form>
      </Modal>

      {(props.type == "new" ||
        props.type == "my" ||
        props.type == "team" ||
        props.type == "fav") && (
        <Row>
          <RowCol span={24}>{userStat()}</RowCol>

          {/* <RowCol span={4} style={{ marginTop: "25px" }}>
            <Button
              loading={statLoading}
              type="danger"
              onClick={() => queryLeadStatCount()}
            >
              刷新
            </Button>
          </RowCol> */}
        </Row>
      )}
      {props.type == "reject" && (
        <Row style={{ margin: "10px" }}>
          <RowCol span={24}>
            <Banner
              fullMode={false}
              type="success"
              bordered
              icon={null}
              closeIcon={null}
              title={
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: "14px",
                    lineHeight: "20px",
                  }}
                >
                  翻新客户规则：
                </div>
              }
              description={
                <div>
                  <Highlight
                    sourceString={sourceString}
                    searchWords={searchWords}
                    highlightStyle={{
                      borderRadius: 6,
                      marginLeft: 4,
                      marginRight: 4,
                      paddingLeft: 4,
                      paddingRight: 4,
                      backgroundColor: "rgba(var(--semi-teal-5), 1)",
                      color: "rgba(var(--semi-white), 1)",
                    }}
                  />
                </div>
              }
            />
          </RowCol>
        </Row>
      )}
      <Crud
        getCrudApi={(crudApiT) => {
          setCrudApi(crudApiT);
          initRefreshInterval(crudApiT);
        }}
        getFilterFormApi={(crudApi, api) => {
          setFilterFormApi(api);
        }}
        initFilterValues={initFilterValues}
        actions={actions}
        select={select}
        fetchDataAfterMethod={queryLeadStatCount}
        canUpdate={false}
        canCreate={
          canCreateLead
        }
        canExport={props.type == "all"}
        name={props.name}
        entityKey="leads"
        params={{
          type: props.type,
          ...initParams,
        }}
        getRowActions={(row) => {
          return [
            {
              name: "详情",
              action: detailAction,
            },
          ];
        }}
        pageSize={pageSize}
        rowActionWidth={60}
        cols={cols}
      />
    </div>
  );
}
